import styled from "styled-components";

export const StoreBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: auto;
    gap: 20px;
`
export const CategoryGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-bottom: 40px;
    gap: 20px;

        @media (max-width: 768px) {
            grid-template-columns: 1fr 1fr;
        }
        @media (max-width: 1024px) and (min-width: 769px) {
            grid-template-columns: 1fr 1fr 1fr;
        }

`

export const Title = styled.h2`
    text-align: "left";
    margin: "20px 0" ;
    color: #636363;
    font-weight: 900;
    font-family: 'Lato';
`

export const TitleBox = styled.div`
    width: 100%;
    margin: 20px 0px 0px 25px;
    @media (max-width: 768px) {
        margin-left: 0px;
        padding-left: 25px;
    }
`

export const StoreImage = styled.img`
    height: 40px;
    width: 40px;
    border-radius: 50%;

    /* @media (max-width: 768px) {
        width: 100px;
    } */

`

export const CategoryBox = styled.div`
    display: flex;
    align-items: center;
    border-radius: 11px;
    padding: 15px;
    cursor: pointer;
    width: 250px;
    height: 30px;
    gap: 8px;
    text-decoration: none;
    font-weight: 400;
    font-family: 'Lato';
    color: #102051;
    box-shadow: 1px 1px 5px #102051;

    &:hover {
        color: white;
        background-color: #102051;
    }

    @media (max-width: 768px) {
        width: 37vw;

            &:active {
                color: white;
                background-color: #102051;
            }
    }
    @media (max-width: 1024px) and (min-width: 769px) {
         width: 200px;
    }
`